import { render, staticRenderFns } from "./CountryProfileMobile.vue?vue&type=template&id=8fb61772&scoped=true&"
import script from "./CountryProfileMobile.vue?vue&type=script&lang=js&"
export * from "./CountryProfileMobile.vue?vue&type=script&lang=js&"
import style0 from "./CountryProfileMobile.vue?vue&type=style&index=0&id=8fb61772&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fb61772",
  null
  
)

export default component.exports